function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "bJHT";


//////////////////
// WEBPACK FOOTER
// ./redevelopment/main/message ^\.\/.*$
// module id = bJHT
// module chunks = 0